import { SPACING } from '@alto/design-library-tokens';
import React from 'react';
import styled from 'styled-components';

const Img = styled.img<{ sidebar?: boolean; center?: boolean }>`
  width: ${({ sidebar }) => (sidebar ? '80px' : '120px')};
  height: ${({ sidebar }) => (sidebar ? '80px' : '120px')};
  margin: 0 auto ${({ sidebar }) => (sidebar ? 0 : SPACING.STATIC.SM.rem)};
  ${({ center }) =>
    center &&
    `
    display: flex;
    text-align: center;
  `}
`;

type Props = {
  readonly src: string;
  readonly alt: string;
  readonly sidebar?: boolean;
  readonly center?: boolean;
};

export const Image: React.FC<Props> = ({ alt, center, src, sidebar }) => {
  return (
    <Img
      center={center}
      src={src}
      alt={alt || ''}
      sidebar={sidebar}
    />
  );
};
